export type PaymentMethod = { value: string; label: string }
export const withdrawalMethodsByCountry: Record<string, PaymentMethod[]> = {
  TG:[{value:'TMONEY',label:'TMoney'},{value:'FLOOZ',label:'Flooz'}],
  CI:[{value:'WAVE',label:'Wave'},{value:'FLOOZ',label:'Flooz'},{value:'ORANGE_MONEY',label:'Orange Money'},{value:'MTN_MONEY',label:'MTN Money'}],
  BJ:[{value:'MOOV_MONEY',label:'Moov Money'},{value:'MTN_MONEY',label:'MTN Money'}],
  SN:[{value:'WAVE',label:'Wave'},{value:'ORANGE_MONEY',label:'Orange Money'},{value:'FREE_MONEY',label:'Free Money'},{value:'MIXX_BY_YAS',label:'Mixx by Yas'}],
}
export const withdrawalCountryCodes = Object.keys(withdrawalMethodsByCountry)
